import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

const ZENDESK_SNIPPET_URL =
  'https://nhlyztrsdeapunrydpni.supabase.co/functions/v1/support-chat/widget.js';
const ZENDESK_SCRIPT_ID = 'ze-snippet';

@Injectable({
  providedIn: 'root',
})
export class ZendeskService {
  private renderer: Renderer2;
  private initPromise: Promise<void> | null = null;
  private initialized = false;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Carga el script de Zendesk de forma dinámica (sin imports estáticos).
   * El script se inserta en el DOM solo al llamar a este método.
   * Resuelve cuando el script ha cargado por completo; evita cargas duplicadas.
   */
  initZendesk(): Promise<void> {
    if (this.initialized) {
      return Promise.resolve();
    }
    if (this.document.getElementById(ZENDESK_SCRIPT_ID)) {
      this.initialized = true;
      return Promise.resolve();
    }
    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = new Promise<void>((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.id = ZENDESK_SCRIPT_ID;
      script.async = true;
      script.defer = true;
      script.src = ZENDESK_SNIPPET_URL;

      script.onload = () => {
        this.initialized = true;
        resolve();
      };
      script.onerror = () => {
        this.initPromise = null;
        reject(new Error('Zendesk snippet failed to load'));
      };

      this.renderer.appendChild(this.document.body, script);
    });

    return this.initPromise;
  }
}

